// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Gcc","footer":"styles_footer__xgg9M","passCodeTooltip":"styles_passCodeTooltip__2iwUe"};